<template>
  <HXContentCard title="Honorarios de Éxito">
    <div class="p-4">
      <div v-if="dataProfesional != ''">
        <h4>
          {{ dataProfesional }}
        </h4>
      </div>
      <b-button
        v-if="profesional && !currentData && isFilter"
        variant="info"
        class="float-right mt-3 mr-3"
        @click="liquidar"
      >
        Liquidar
      </b-button>
    </div>
    <div class="row px-3 ml-1 mb-4">
      <div class="col-2 px-0">
        <h4 class="mb-2"><b>Mes:</b></h4>
        <b-select
          v-model="mesSeleccionado"
          class="form-control bg-dark personalizado"
          :options="listaMes"
          text-field="mes"
          value-field="id"
        />
      </div>
      <div class="col-2 px-1">
        <h4 class="mb-2"><b>Año:</b></h4>
        <b-select
          v-model="anioSeleccionado"
          class="form-control bg-dark personalizado"
          :options="listaAnios"
        />
      </div>
      <div class="col px-1">
        <h4 class="mb-2"><b>Filtrar x profesional:</b></h4>
        <v-select
          required
          class="style-chooser"
          :reduce="(value) => value"
          v-model="profesional"
          :options="listaProfesional"
          label="nombreProfesional"
          placeholder="-- selecciona un profesional --"
          @input="seleccionaProfesional()"
        ></v-select>
      </div>
      <div class="col px-1">
        <h4 class="mb-2"><b>Filtrar x sucursal:</b></h4>
        <v-select
          required
          class="style-chooser"
          :reduce="(value) => value"
          v-model="sucursal"
          :options="listaSucursal"
          label="sucursal"
          placeholder="-- selecciona sucursal --"
          @input="seleccionaSucursal()"
        ></v-select>
      </div>
      <div class="col-1 px-1 mt-3">
        <vs-button primary icon class="px-2" @click="filtrar" id="sendform2">
          <i class="fas fa-search"></i>
        </vs-button>
      </div>
    </div>
    <div class="p-4">
      <!-- top info -->
      <div class="d-flex flex-wrap" style="gap: 1rem">
        <div class="bg-dark rounded py-2 px-3">
          <span>Fecha ingreso</span>
          <h4>
            {{
              fechaIngreso ? $moment(fechaIngreso).format("DD/MM/YYYY") : "---"
            }}
          </h4>
        </div>
        <div class="bg-dark rounded py-2 px-3">
          <span>Tiempo de prestación de servicio</span>
          <h4>{{ tiempoPrestacion ?? "---" }}</h4>
        </div>
        <div class="bg-dark rounded py-2 px-3">
          <span>Categoría</span>
          <h4>{{ categoria ?? "---" }}</h4>
        </div>
      </div>

      <!-- tables schemas -->
      <section>
        <div v-for="item in tablesSchemas" :key="item.id">
          <div class="m-3">
            <h4 class="d-flex justify-content-between">
              <b>{{ item.title }}</b>

              <b>
                {{
                  item.totalValor.toLocaleString("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                }}
              </b>
            </h4>
          </div>
          <vs-table striped>
            <template #notFound>
              <span>No se encontraron resultados</span>
            </template>
            <template #header>
              <vs-input v-model="item.search" border placeholder="Buscar..." />
            </template>
            <template #thead>
              <vs-tr>
                <vs-th
                  v-for="(th, idx) in item.headers"
                  :key="idx"
                  sort
                  @click="item.data = $vs.sortData($event, item.data, th)"
                  >{{ th }}</vs-th
                >
              </vs-tr>
            </template>
            <template #tbody>
              <vs-tr
                v-for="row in $vs.getPage(
                  $vs.getSearch(item.data, item.search),
                  item.page,
                  max
                )"
                :data="row"
                :key="row.id"
              >
                <vs-td v-for="(value, key) in row" :key="key">
                  <span
                    v-if="
                      ['valor', 'incentivo'].some((word) =>
                        key.toLowerCase().includes(word)
                      )
                    "
                  >
                    {{
                      value.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })
                    }}
                  </span>
                  <span v-else-if="key.toLowerCase() === 'fechapresupuesto'">
                    {{ $moment(value).format("MMMM, YYYY") }}
                  </span>
                  <span v-else-if="key.toLowerCase().includes('fecha')">
                    {{ $moment(value).format("DD/MM/YYYY") }}
                  </span>
                  <span
                    v-else-if="
                      ['tasa', 'porcentajecumplimiento'].some((word) =>
                        key.toLowerCase().includes(word)
                      )
                    "
                  >
                    {{ (value * 100).toFixed(2) }}%
                  </span>
                  <span v-else>
                    {{ value }}
                  </span>
                </vs-td>
              </vs-tr>
            </template>
            <template v-if="item.data?.length > 0" #footer>
              <vs-pagination
                v-model="item.page"
                :length="
                  $vs.getLength($vs.getSearch(item.data, item.search), max)
                "
              />
            </template>
          </vs-table>
        </div>
      </section>
      <!-- honorarios liquidados -->

      <h4 class="text-white-50 mt-3">
        <b>Honorarios liquidados</b>
        <i class="fas fa-circle-check ml-1"></i>
      </h4>
      <hr />

      <div class="row">
        <div class="col-12 col-md-2">
          <label for="filterDate" class="form-label"
            ><i class="fas fa-calendar-days"></i> Periodo liquidación:</label
          >
          <input
            id="date"
            type="month"
            class="form-control"
            v-model="currentFilterDate"
            @input="handleFilterDateInput"
          />
        </div>
      </div>

      <div class="mt-3">
        <vs-table striped>
          <template #notFound>
            <span>No se encontraron resultados</span>
          </template>
          <template #header>
            <vs-input v-model="search" border placeholder="Buscar..." />
          </template>
          <template #thead>
            <vs-tr>
              <vs-th
                v-for="header in headers"
                :key="header"
                :colspan="encabezadosCombinados(header)"
                sort
                @click="
                  honorariosLiquidados = $vs.sortData(
                    $event,
                    honorariosLiquidados,
                    header
                  )
                "
              >
                {{ header }}
              </vs-th>
            </vs-tr>
          </template>
          <template #tbody>
            <!-- Primera fila fija -->
            <vs-tr :data="firtsRow" key="header-row">
              <vs-td v-for="(cell, idx) in firtsRow" :key="'header-' + idx">
                {{ cell }}
              </vs-td>
            </vs-tr>

            <!-- Datos filtrados y paginados -->
            <vs-tr
              v-for="(row, index) in paginatedData"
              :key="'row-' + index"
              :data="row"
            >
              <vs-td
                v-for="(cell, idx) in row"
                :key="'cell-' + index + '-' + idx"
              >
                {{ cell | formatValue(idx) }}
              </vs-td>
            </vs-tr>
          </template>
          <template #footer>
            <vs-pagination
              v-model="page"
              :length="
                $vs.getLength($vs.getSearch(honorariosLiquidados, search), max)
              "
            />
          </template>
        </vs-table>
      </div>
    </div>
  </HXContentCard>
</template>

<script>
const Swal = require("sweetalert2");

import tablesSchemas from "./tablesSchemasLiquidacionHonorariosExito.js";

export default {
  components: {},
  data() {
    return {
      tablesSchemas: [...tablesSchemas],
      listaMes: [
        { id: 1, mes: "Enero" },
        { id: 2, mes: "Febrero" },
        { id: 3, mes: "Marzo" },
        { id: 4, mes: "Abril" },
        { id: 5, mes: "Mayo" },
        { id: 6, mes: "Junio" },
        { id: 7, mes: "Julio" },
        { id: 8, mes: "Agosto" },
        { id: 9, mes: "Septiembre" },
        { id: 10, mes: "Octubre" },
        { id: 11, mes: "Noviembre" },
        { id: 12, mes: "Diciembre" },
      ],
      tiempoPrestacion: null,
      fechaIngreso: null,
      categoria: null,
      honorariosLiquidados: [],
      listaAnios: [],
      mesSeleccionado: null,
      anioSeleccionado: null,
      persona: {},
      listaProfesional: [],
      listaProfesionalBk: [],
      listaSucursal: [],
      currentData: null,
      profesional: null,
      sucursal: null,
      rutProfesional: "",
      dataProfesional: "",
      isFilter: false,
      currentFilterDate: null,
      search: "",
      page: 1,
      max: 10,
      headers: [
        "CLINICA",
        "IDENTIFICACION",
        "NOMBRE",
        "FECHA DE INGRESO",
        "TIEMPO DE PRESTACION DE SERVICIOS",
        "CATEGORIA",
        "PRIMEROS ABONOS PARA CUMPLIMIENTO",
        "META DE PRIMEROS ABONOS",
        "CUMPLIMIENTO",
        "PORCENTAJE A CANCELAR",
        "PRIMEROS ABONOS LIQUIDACION",
        "SUBVENCION Y GASTOS FINANCIEROS",
        "DEVOLUCIONES",
        "TOTAL PRIMEROS ABONOS LIQUIDACION ",
        "NOTA DEBITO CONVENIOS / ALIANZAS",
        "INCENTIVO DE PRIMEROS ABONOS SIN CUMPLIMIENTO DE META",
        "INCENTIVO DE PRIMEROS ABONOS CON CUMPLIMIENTO DE META",
        "CIERRES DE ORTODONCIA",
        "IMPLANTES MONTADOS",
        "MONTAJES DE ORTODONCIA",
        "PACIENTES QUE INICIAN",
        "HONORARIOS DE ÉXITO PACKS",
        "GARANTIZADO",
        "NOTA DEBITO CONVENIOS / ALIANZAS",
        "INCREMENTO OCACIONAL",
        "OTROS",
        "TOTAL",
      ],
      firtsRow: [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        "PREMIUM",
        "META",
        "Cump %",
        "INCENTIVO",
        "PLUS",
        "PREMIUM",
        "CANTIDAD",
        "INCENTIVO",
        "NUMERO",
        "INCENTIVO",
        "NUMERO",
        "META",
        "Cumpl %",
        "INCENTIVO",
        "INICIOS",
        "META",
        "INCENTIVO",
        null,
        null,
        null,
        null,
        null,
        null,
      ],
    };
  },
  async mounted() {
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));

    this.handleInitDate();
    await this.getHonorariosLiquidados();
    await this.getProfesionalesYSucursales();
  },
  computed: {
    filteredData() {
      return this.honorariosLiquidados.filter((row) => {
        // Convertir el objeto `row` en un array de valores
        const cells = Object.values(row);

        // Verificar si alguna celda incluye el término de búsqueda
        return cells.some((cell) =>
          String(cell).toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    paginatedData() {
      const start = (this.page - 1) * this.max;
      const end = this.page * this.max;
      return this.filteredData.slice(start, end);
    },
  },
  methods: {
    async getHonorariosLiquidados(anio = null, mes = null) {
      try {
        this.$isLoading(true);

        const path =
          anio && mes
            ? `MisHonorariosExito/GetDataByFecha/${anio}/${mes}`
            : "MisHonorariosExito/GetDataByFecha";
        let res = await this.$store.dispatch("denti_get", { path });

        console.log("res", res);

        if (res && res.data.length) {
          // obtener ultima fecha de liquidacion
          this.currentFilterDate = `${res.data[0].anio}-${String(
            res.data[0].mes
          ).padStart(2, "0")}`;

          //excluir campos
          res.data = res.data.map((item) => {
            // eslint-disable-next-line no-unused-vars
            const { id, anio, mes, ...rest } = item;
            return rest;
          });

          this.honorariosLiquidados = res.data;
        } else {
          console.log("No se encontraron datos");
          this.honorariosLiquidados = [];
        }

        this.$isLoading(false);
      } catch (error) {
        console.error("Error al obtener los honorarios:", error);
        this.$isLoading(false);
        this.showToast("error", "Hubo un error al obtener los honorarios");
      }
    },
    async handleFilterDateInput() {
      const [anio, mes] = this.currentFilterDate.split("-");
      await this.getHonorariosLiquidados(anio, mes);
    },
    encabezadosCombinados(header) {
      if (header == "CIERRES DE ORTODONCIA") return 9;
      if (header == "IMPLANTES MONTADOS") return 2;
      if (header == "MONTAJES DE ORTODONCIA") return 4;
      if (header == "PACIENTES QUE INICIAN") return 3;
    },
    handleInitDate() {
      const anioActual = new Date().getFullYear();
      const anioInicio = anioActual - 2;
      const listaAnios = [];

      for (let anio = anioInicio; anio <= anioActual; anio++) {
        listaAnios.push(anio);
      }
      this.listaAnios = listaAnios;
      this.mesSeleccionado = new Date().getMonth() + 1;
      this.anioSeleccionado = new Date().getFullYear();
    },
    async obtenerDataProfesional() {
      let Persona = await this.$store.dispatch("hl_get", {
        path: "Persona/GetPersonaPorDocumento/" + this.rutProfesional,
      });
      console.log("persona0", Persona);
      if (Object.prototype.hasOwnProperty.call(Persona, "id")) {
        let dataProfesional = await this.$store.dispatch("hl_get", {
          path:
            "FormalEducation/GetByPersonaId/" +
            Persona.id +
            "/" +
            Persona.empresaId,
        });
        console.log("persona-->", dataProfesional);
        if (dataProfesional.length > 0) {
          this.dataProfesional = dataProfesional[0].degree;
        }
      } else {
        this.dataProfesional = "";
        this.dataProfesional =
          "Ficha del profesional no encontrada en Personas";
      }
    },
    async seleccionaProfesional() {
      this.rutProfesional = this.profesional.rut;
      this.profesional = this.profesional.nombreProfesional;
      this.sucursal = null;
      this.isFilter = false;

      await this.obtenerDataProfesional();
    },
    async seleccionaSucursal() {
      this.sucursal = this.sucursal.sucursal;
      this.isFilter = false;
      await this.obtenerDataProfesional();
    },
    async getProfesionalesYSucursales() {
      try {
        this.$isLoading(true);
        let res = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ListaProfesionales/",
        });
        this.listaProfesionalBk = [...res];

        let uniqueProfesionales = new Set();

        this.listaProfesional = res
          .map((x) => {
            console.log("x-->0", x);
            let nombreProfesional = null;
            if (x.nombreProfesional != null && x.nombreProfesional.length > 0) {
              let resulta = x.nombreProfesional.split(",");
              const normalize = (nombre) =>
                nombre
                  .trim()
                  .toLowerCase()
                  .replace(/\s+/g, " ")
                  .replace(",", "");
              nombreProfesional =
                resulta.length > 1
                  ? normalize(resulta[1]) + " " + normalize(resulta[0])
                  : normalize(resulta[0]);

              console.log("x-->1", nombreProfesional);
            }

            // Verificar si el nombreProfesional es único
            if (
              nombreProfesional &&
              !uniqueProfesionales.has(nombreProfesional)
            ) {
              uniqueProfesionales.add(nombreProfesional);
              // return { nombreProfesional: nombreProfesional, rut: x.idPaciente };
              return { nombreProfesional: nombreProfesional, rut: x.rut };
            }

            return null; // Ignorar duplicados
          })
          .filter((item) => item !== null); // Eliminar valores nulos del resultado

        console.log("x-->3", this.listaProfesional);
        let resSucursales = await this.$store.dispatch("denti_get", {
          path: "Prestaciones/ListaSucursales/",
        });
        this.listaSucursal = resSucursales;
        //  await resSucursales.map((x) => {
        //   return x.sucursal;
        // }, 0);
        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        console.log("error", error);
      }
    },
    async getFechaIngresoPersona(personaId) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Persona/GetFechaIngresoPersona/" + personaId,
        });
        return res;
      } catch (error) {
        console.log("err", error);
        return null;
      }
    },
    async liquidar() {
      try {
        Swal.fire({
          title: "¿Quieres Liquidar?",
          text: "Después de liquidar no podrás modificar datos!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Si!",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.value) {
            this.$isLoading(true);

            console.log("ok");

            let fechaIngreso = await this.getFechaIngresoPersona(
              this.rutProfesional
            );

            if (!fechaIngreso) return;

            console.log("fechaIngreso", fechaIngreso);

            let data = {
              clinica: this.sucursal,
              rutProfesional: this.rutProfesional,
              nombre: this.profesional,
              mes: this.mesSeleccionado,
              anio: this.anioSeleccionado,
              fechaIngreso,
              tiempoPrestacionServicio: null,
              categoria: null,
            };

            console.log(data);
            let res = await this.$store.dispatch("denti_post", {
              path: "MisHonorariosExito/Liquidar",
              data,
            });

            console.log(res);

            if (res && res.data.id) {
              this.currentData = res.data;

              // Obtener el período del honorario liquidado
              const periodoLiquidado = `${res.data.anio}-${String(
                res.data.mes
              ).padStart(2, "0")}`;

              // Verificar si coincide con el período seleccionado (currentFilterDate)
              if (this.currentFilterDate === periodoLiquidado) {
                // Excluir campos innecesarios
                // eslint-disable-next-line no-unused-vars
                const { id, anio, mes, ...rest } = res.data;

                // Insertar nueva liquidación en la lista
                this.honorariosLiquidados.push(rest);

                Swal.fire(
                  "Muy Bien!",
                  "Liquidación generada correctamente!",
                  "success"
                );
              } else {
                Swal.fire(
                  "Muy Bien!",
                  `El honorario fue liquidado en el período ${periodoLiquidado}, puedes verlo cambiando el periodo de liquidación`,
                  "success"
                );
              }
            }

            this.$isLoading(false);
          }
        });
      } catch (error) {
        this.$isLoading(false);
        console.log("error", error);
      }
    },
    showToast(type, message) {
      console.log(type);
      if (type == "success") {
        this.$toast.success(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
      if (type == "error")
        this.$toast.error(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      if (type == "warning")
        this.$toast.warning(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
    },
    async filtrar() {
      if (!this.profesional || !this.sucursal) return;
      try {
        this.$isLoading(true);

        this.isFilter = true;

        let mesSeleccionado =
          new Date(
            this.anioSeleccionado + "/" + this.mesSeleccionado + "/01"
          ).getMonth() + 1;

        console.log("mesSeleccionado", mesSeleccionado);

        let anioSeleccionado = this.anioSeleccionado; //new Date().getFullYear();

        await this.getData(anioSeleccionado, mesSeleccionado);

        this.$isLoading(false);
      } catch (error) {
        this.isFilter = false;
        this.$isLoading(false);
        console.log("error", error);
      }
    },
    async getCategoriaTiempoPrestacion() {
      try {
        let fechaIngreso = await this.getFechaIngresoPersona(
          this.rutProfesional
        );

        if (!fechaIngreso) return;

        let res = await this.$store.dispatch("denti_get", {
          path: `MisHonorariosExito/categoriaTiempoPrestacion/${this.rutProfesional}/${fechaIngreso}/${this.anioSeleccionado}/${this.mesSeleccionado}`,
        });
        console.log("res", res);
        if (res.data != null) {
          this.fechaIngreso = res.data.fechaIngreso;
          this.categoria = res.data.categoria;
          this.tiempoPrestacion = res.data.tiempoPrestacionServicio;
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    async getData(anio, mes) {
      try {
        this.$isLoading(true);
        console.log("profesional", this.profesional, this.rutProfesional);
        console.log("sucursal", this.sucursal);
        console.log("anio", anio, mes);

        await this.getCategoriaTiempoPrestacion();

        let resumen = await this.$store.dispatch("denti_get", {
          path: `MisHonorariosExito/resumen/${this.rutProfesional}/${anio}/${mes}/${this.sucursal}`,
        });
        console.log("data", resumen);

        this.tablesSchemas.forEach((table) => {
          if (resumen[table.name]) {
            // eslint-disable-next-line no-unused-vars
            table.data = resumen[table.name].map(({ id, ...rest }) => rest);

            // valores totales
            if (table.name == "devoluciones") {
              table.totalValor = resumen[table.name].reduce(
                (total, curr) => total + curr["valor"],
                0
              );
            }

            if (table.name == "packsHigienicos") {
              table.totalValor = resumen[table.name].reduce(
                (total, curr) => total + curr["incentivo"],
                0
              );
            }

            if (table.name == "subvenciones") {
              table.totalValor = resumen[table.name].reduce(
                (total, curr) => total + curr["valorDescuento"],
                0
              );
            }
          }
        });

        let res = await this.$store.dispatch("denti_get", {
          path: `MisHonorariosExito/GetData/${anio}/${mes}/${this.rutProfesional}/${this.sucursal}`,
        });
        console.log("res", res);
        if (res && res.data?.id) {
          this.currentData = res.data;
        } else {
          this.currentData = null;
        }

        this.$isLoading(false);
      } catch (error) {
        this.$isLoading(false);
        console.log("error", error);
        await Swal.fire({
          icon: "error",
          title: "Error inesperado",
          text: "Ocurrió un problema al obtener los datos. Por favor, intenta nuevamente.",
        });
      }
    },
  },
  filters: {
    formatValue(value, idx) {
      // console.log("value", value, idx);

      if (value === undefined || value === null) return "";

      const formatters = {
        currency: [
          6, 7, 10, 11, 12, 13, 14, 15, 16, 21, 25, 27, 31, 34, 35, 37, 40,
        ],
        date: ["fechaIngreso"],
        percentage: [8, 9, 20, 30],
        numberWithCommas: [4, 19, 29, 33],
      };

      if (typeof value === "number") {
        if (formatters.currency.includes(idx)) {
          // Formatear como moneda
          return new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            maximumFractionDigits: 0,
          }).format(value);
        } else if (formatters.percentage.includes(idx)) {
          // Formatear como porcentaje
          return (value * 100).toFixed(1) + "%";
        } else if (formatters.numberWithCommas.includes(idx)) {
          // Redondear a un decimal y luego formatear con separadores de miles
          return new Intl.NumberFormat("es-CO").format(
            Math.round(value * 10) / 10
          );
        }
      } else if (typeof value === "string" && formatters.date.includes(idx)) {
        // Si el valor es una cadena de fecha en formato ISO (2020-03-12T00:00:00)
        const date = new Date(value);
        console.log("date", date);

        if (!isNaN(date.getTime())) {
          // Verificar que la fecha sea válida
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Meses son de 0 a 11
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`; // Formato deseado: 2020-03-12
        }
      }

      return value;
    },
  },
};
</script>
